import React from "react";

/**
 * <ExternalLink href="https://...">Label</ExternalLink>
 *
 * Renders an anchor that opens its href in a new top-level browsing context.
 *
 * Spec-correct, race-free implementation:
 *   • `target="_blank"` tells the browser to open a NEW top-level browsing
 *     context. By spec this does NOT navigate the current document.
 *   • `rel="noopener noreferrer"` denies the popup access to window.opener
 *     and strips the Referer — security best practice for untrusted targets.
 *
 * We deliberately do NOT attach a JS opener (onClick / onMouseDown calling
 * window.open). Layering a JS opener races with the browser's native popup
 * and was observed to produce two new tabs in this environment.
 */
export default function ExternalLink({
  href,
  children,
  className = "",
  as: Tag = "a",
  testid,
  ...rest
}) {
  return (
    <Tag
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={className}
      {...rest}
    >
      {children}
    </Tag>
  );
}
